import { FC } from "react"

import { SortIcon } from "src/assets";
import { TableHeaderProps } from "./types"



export const TableHeader: FC<TableHeaderProps> = ({ tableHeader, sortConfig, classNames, changeIdOrder }): JSX.Element => {
  return (
    <th
      scope="col"
      onClick={tableHeader.value !== "" ? () => changeIdOrder(tableHeader.value) : () => {}}
      className={classNames || "align-middle"}
      style={tableHeader.width === "" ? {} : { width: tableHeader.width }}
    >
      <span
        role={tableHeader.value === "" ? "textbox" : "button"}
        className={
          tableHeader.value === "" ?
            "fw-bold fs-6 lh-base user-select-text" :
            "p-0 fw-bold fs-6 text-black table-header-link d-inline-flex align-items-center gap-1 user-select-text"
        }
      >
        <span role="link" className="user-select-text">{tableHeader.label}</span>
        {tableHeader.value !== "" && (
          sortConfig.sort_by === tableHeader.value ? (
            <i className={`bi ${sortConfig.direction === "desc" ? "bi-caret-down-fill" : "bi-caret-up-fill"}`}></i>
          ) : (
            <img width={16} height={16} alt="sorting icon" src={SortIcon} />
          )
        )}
      </span>
    </th>
  )
}

export default TableHeader;
